export {default as AttributeText} from './AttributeText';
